import React from 'react';

// import components

import Banner from '../components/Banner';

const Home = () => {
  return (
    <div className='min-h-[1800px]'>
      <Banner />
     
    </div>
  );
};

export default Home;
